import historyProvider from './historyProvider.js'

var _subs = []



export default {
 subscribeBars: function(symbolInfo, resolution, updateCb, uid, resetCache) {
    const channelString = createChannelString(symbolInfo)
  
    var newSub = {
    channelString,
    uid,
    resolution,
    symbolInfo,
    lastBar: historyProvider.history[symbolInfo.name].lastBar,
    listener: updateCb,
    }
  _subs.push(newSub)
 },
 unsubscribeBars: function(uid) {
    var subIndex = _subs.findIndex(e => e.uid === uid)
    if (subIndex === -1) {
    //console.log("No subscription found for ",uid)
    return
    }
    var sub = _subs[subIndex]
    _subs.splice(subIndex, 1)
  }
}

function connectWebSocket() {
  const webSocket = new WebSocket('wss://me-ta-proplus.com:9394');

  webSocket.onopen = ()=>{ 
    console.log("Socket Connected!"); 
  }; 
    // 2-2) 메세지 수신 이벤트 처리 
  webSocket.onmessage = function (result) { 
    console.log(result);
    var e = JSON.parse(result.data);

    const data = {
      sub_type: 0, //parseInt(0, 10), // ???
      exchange: "PEPPERSTONE", // 거래소이름
      to_sym: 'NAS100', //e.code.split("-")[1], // coinTicker
      from_sym: '1', //e.code.split("-")[0], // market
      // trade_id: _data[5],
      trade_id: "",
      ts: e.time / 1000, // timestamp
    // volume: e.trade_volume, // 거래량
      open: e.open,
      high: e.high,
      low: e.low,
      close: e.close,
      price: e.close // 가격
    };

    const channelString = `${data.sub_type}~${data.exchange}~${data.to_sym}~${data.from_sym}`;

    const sub = _subs.find(e => e.channelString === channelString);
    //console.log(sub)

    for(var i = 0; i < _subs.length; i++)	{
    if (data.ts < _subs[i].lastBar.time / 1000) {
        return;
      }

      var _lastBar = updateBar(data, _subs[i]);

      // send the most recent bar back to TV's realtimeUpdate callback
      _subs[i].listener(_lastBar);
      // update our own record of lastBar
      _subs[i].lastBar = _lastBar;
    }
    /*
    if (sub) {
      // disregard the initial catchup snapshot of trades for already closed candles
      if (data.ts < sub.lastBar.time / 1000) {
        return;
      }

      var _lastBar = updateBar(data, sub);

      // send the most recent bar back to TV's realtimeUpdate callback
      sub.listener(_lastBar);
      // update our own record of lastBar
      sub.lastBar = _lastBar;
    }*/
  } 
    // 2-3) 연결 종료 이벤트 처리 
  webSocket.onclose = function(){ 
    console.log("서버 웹소켓 연결 종료"); 

    setTimeout(connectWebSocket, 1000); // 1초 후 다시 연결 시도
  } 
    // 2-4) 에러 발생 이벤트 처리 
  webSocket.onerror = function(event){ 
    console.log(event) 
  } 
}

connectWebSocket();

function updateBar(data, sub) {
  var lastBar = sub.lastBar
  let resolution = sub.resolution
  if (resolution.includes('D')) {
  // 1 day in minutes === 1440
  resolution = 1440
  } else if (resolution.includes('W')) {
  // 1 week in minutes === 10080
  resolution = 10080
  }

  var coeff = resolution * 60
  // console.log({coeff})
  var rounded = Math.floor(data.ts / coeff) * coeff
  var lastBarSec = lastBar.time / 1000
  var _lastBar
  
  if (rounded > lastBarSec) {
  // create a new candle, use last close as open **PERSONAL CHOICE**
    _lastBar = {
      time: rounded * 1000,
      open: lastBar.close,
      high: lastBar.close,
      low: lastBar.close,
      close: data.price,
      //volume: data.volume
    }
  
  } else {
  // update lastBar candle!
  
  //lastBar.volume += data.volume
    lastBar.open = data.open
    lastBar.high = data.high
    lastBar.low = data.low
    lastBar.close = data.close
    _lastBar = lastBar
  }
  return _lastBar
 }
  
function createChannelString(symbolInfo) {
  var channel = symbolInfo.name.split(/[:/]/)
  const exchange = channel[0] === 'GDAX' ? 'Coinbase' : channel[0]
  const to = channel[2]
  const from = channel[1]
 // subscribe to the CryptoCompare trade channel for the pair and exchange
  return `0~${exchange}~${from}~${to}`
}


// WEBPACK FOOTER //
// ./src/components/TVChartContainer/api/stream.js